import React, { useState, useRef, useEffect } from 'react';
import './TextArea.css'; // Import the CSS file

const TextArea = ({ placeholder, onTextChanged }) => {
  const [value, setValue] = useState('');
  const textAreaRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (textAreaRef.current) {
        textAreaRef.current.style.height = 'auto';
        textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
      }
    };

    handleResize(); // Initial resize
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [value]);

  const handleChange = (e) => {
    const currentText = e.target.value;
    setValue(currentText);
    onTextChanged(currentText);
  };

  return (
    <textarea
      placeholder={placeholder}
      ref={textAreaRef}
      className="custom-textarea"
      value={value}
      onChange={handleChange}
      onPaste={handleChange}
    />
  );
};

export default TextArea;
